import { Component, OnDestroy } from "@angular/core";

import { Subscription } from "rxjs/Rx";

import { CurrentUserService } from "../services/current-user.service";
import { AuthDataService } from "../services/auth-data.service";
import { CookieService } from "angular2-cookie/core";
import { BrowserWidthService } from "../services/browser-width.service";

@Component({
    selector: 'change-retailer-confirmation',
    template: require('./change-retailer-confirmation.component.html'),
    styles: [require('./change-retailer-confirmation.component.scss')]
})

export class ChangeRetailerConfirmationComponent implements OnDestroy {
    
    headerText: string = 'Confirmation';
    message: string = 'Changing retailers will save the current quote and redirect you to the quotes list for the new retailer. Continue?'
    cancelText: string = 'No';
    okayText: string = 'Yes';
    cmhBaseUrl: string;
    subscription: Subscription = new Subscription();

    constructor(
        public currentUserService: CurrentUserService,
        public authDataService: AuthDataService,
        public browserWidthService: BrowserWidthService
    ) {
        const sub = this.currentUserService.changeRetailerModalViewStatus$.subscribe(x => {
            this.browserWidthService.setScroll(x);
        });
        this.subscription.add(sub);
    }
 
    close(msg?: string) {
        if(msg) {
            this.currentUserService.changeRetailerModalViewStatus$.next(false);
            this.authDataService.setRetailer(true);
        } else {
            this.currentUserService.changeRetailerModalViewStatus$.next(false);
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/change-retailer-confirmation/change-retailer-confirmation.component.ts